import { Component, ElementRef, Input, OnInit, ViewChild, OnChanges, ViewChildren, QueryList } from '@angular/core';
import { IPublicationDocument } from 'src/app/core/actions/entity/publicationDocument';
import { PublicationFileGetByDocumentIdService } from 'src/app/core/actions/use-case/publication-file-get-by-document-id.service';
import { PublicationFileLocalRepositoryService } from 'src/app/module/actions/data/repository/publication-file-local-repository.service';
import { PublicationFileRemoteRepositoryService } from 'src/app/module/actions/data/repository/publication-file-remote-repository.service';
import { checkFileTypeService } from 'src/app/services/checkFileType.service';
import { StopvideoService } from 'src/app/services/stopvideo.service';
import { v4 as uuidv4 } from 'uuid'
@Component({
  selector: 'app-swiper',
  templateUrl: './swiper.page.html',
  styleUrls: ['./swiper.page.scss'],
})
export class SwiperPage implements OnInit {

  publicationList: IPublicationDocument[] = [];
  @Input() navigation: boolean;
  @Input() pagination: boolean;
  @Input() processId: number;
  @Input() documentId: number;
  @Input() datePublication: string;
  swiperIndex: number = 0;

  @ViewChildren('videoElement') videoElements: QueryList<ElementRef>;
  @ViewChild('swipers')
  swiperRef: ElementRef | undefined;

  showControls: boolean = false;
  previousIndex: number | undefined;
  componentId = uuidv4()

  constructor(
    public checkFileType: checkFileTypeService,
    public stopvideoService: StopvideoService,
    private local: PublicationFileLocalRepositoryService,
    private remote: PublicationFileRemoteRepositoryService,
    private publicationFileGetByDocumentIdService: PublicationFileGetByDocumentIdService
  ) {}

  ngOnInit() {

    this.local.find({documentId: this.documentId}).then(async e => {
      if(e.isOk() && e.value.length == 0) {
        var result = await this.publicationFileGetByDocumentIdService.execute({
          documentId: this.documentId,
          processId: this.processId,
          datePublication: this.datePublication
        });

        if(result.isOk()) {
          this.publicationList = result.value.added;
          this.makeLoad();
        }
      } else if(e.isOk()) {
        this.publicationList = e.value;
        this.makeLoad();

        var a = e.value.find(e => e.datePublication != this.datePublication)
        if(a) {
          var result = await this.publicationFileGetByDocumentIdService.execute({
            documentId: this.documentId,
            processId: this.processId,
            datePublication: this.datePublication
          });

          if(result.isOk()) {
            this.publicationList = result.value.added;
            this.makeLoad();
          }
        }
      }
    });
  }

  makeLoad() {
    // Check if there’s at least one video in the publication list
    const hasVideo = this.publicationList.some(pub =>
      this.checkFileType.checkFileType(pub.extension) === 'video'
    );
    // If there are no videos, skip everything
    if (!hasVideo) return;
    // Load all videos after 100ms
    setTimeout(() => {
      try {
        const videos: NodeListOf<HTMLVideoElement> = document.querySelectorAll(
          `#C${this.componentId} video`
        );
        videos.forEach(video => video.load());
      } catch (e) {
        console.error('Error loading videos:', e);
      }
    }, 100);
  }


  ngOnChanges() {
    this.onSlideChange()
  }

  onSlideChange() {

    if (this.swiperRef) {

      const swiper = this.swiperRef.nativeElement.swiper;
      this.swiperIndex = swiper.activeIndex;

      // Check if the currentIndex is different from the previousIndex
      if (this.swiperIndex !== this.previousIndex) {
        console.log('Active index changed. New index:', this.swiperIndex);
        // Update the previousIndex with the currentIndex
        this.previousIndex = this.swiperIndex;
        this.loadVideo()

      } else {
        console.log(this.swiperIndex)
      }

    }
  }

  goToSlide(index: number) {
    this.swiperIndex = this.swiperRef?.nativeElement.swiper.activeIndex;
    this.swiperRef?.nativeElement.swiper.slideTo(index);
    console.log('index slide', index)
  }

  onVisibilityChange = (e: boolean) => {
    if (!e) {
      this.stopVideo()
    }
  }

  stopVideo() {
    var videos = document.querySelectorAll('video');

    try {
      // Pause each video
      videos.forEach(function (video) {
        video.pause();
      })

      this.videoElements.forEach(videoElement => {
        // You can access the native HTML video element using videoElement.nativeElement
        const video: HTMLVideoElement = videoElement.nativeElement;

        video.pause()
        // Do something with each video element
        // console.log(video);
      });


    } catch (error) {
      console.log(error)
    }
  }

  click() {
    this.onSlideChange()
  }
  //This method does the refresh of all video(it was implement beacouse of the erro displaing the controls of the video while swipe)
  //If you can find a better solution, please remove
  loadVideo() {

    try {

      const file = this.publicationList[this.swiperIndex]
      if(this.checkFileType.checkFileType(file.extension ) == 'video') {

        const video = document.querySelector(`#C${this.componentId} .swiper-slide-active video`) as HTMLVideoElement
        if(video) {

          // video.load();
          video.removeAttribute('controls');
          setTimeout(() => {
            video.setAttribute('controls', 'controls');
          }, 500)
        }

      }

    } catch (error) {
      console.log(error)
    }
  }

}


